function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M90.0019 0H0V60H90.0019V0Z",
  fill: "#F0F0F0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0437 30.0002L0 9.94751V50.0564L20.0437 30.0002Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3351 30.0001L0 1.646V9.94762L20.0437 30.0003L0 50.0565V58.3426L28.3351 30.0001Z",
  fill: "#FFDA44"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M89.621 35.8696C89.6312 35.7923 89.7623 35.7153 90.0019 35.6379V30V24.1304H89.621H39.1301L14.9997 0H0V1.64587L28.3351 30L0 58.3425V60H14.9997L39.1301 35.8696H89.621Z",
  fill: "#6DA544"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M88.4518 41.7395H41.5615L23.3008 60H90.002V41.7395H88.4518Z",
  fill: "#0052B4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M88.4518 18.2605H90.002V0H23.3008L41.5615 18.2605H88.4518Z",
  fill: "#D80027"
});

var SvgZar = function SvgZar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 60,
    viewBox: "0 0 91 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ZAR.57a64d94.svg";
export { ForwardRef as ReactComponent };